import { IGatsbyImageData } from 'gatsby-plugin-image';

export type OpportunitySalary = {
  upper?: number | undefined | null;
  lower?: number | undefined | null;
  currency: string;
  display?: string | null;
  ranges?: string[];
};

export enum OpportunityCurrency {
  GBP = 'GBP',
  EUR = 'EUR'
}

export type OpportunityType = {
  id: string;
  title: string;
};

export interface OpportunityDetails {
  opportunityStartDateDDMMYYYDotted: string | string[] | null;
  applicationDeadlineDDMMYYYDotted: string | null;
  showDaysLeft: boolean;
  daysLeft: number | null;
  salary: OpportunitySalary;
  applicationOpen: boolean;
}

/** @todo: need to be removed and replaced with Opportunity class */
export type ApplyJobInfo = {
  id: string; // required for backend
  title: string; // required for backend // required for form
  url: string; // required for backend
  orgId: string; // required for tracking
  orgName: string; // required for form
  orgLogo: IGatsbyImageData | string | null; // required for form
  orgPath: string; // required for form
  sourceOrgName?: string;
  fullDetails: any;
  freeJob: string;
  scrapedJob: string;
  applicationOpen: boolean;
};
